import {
  ToDo,
} from 'types/toDo';

export default function preserveReadToDoPositions(
  currentToDos: ToDo[],
  refreshedToDos: ToDo[],
  locallyReadToDoIds: Set<number>,
): ToDo[] {
  const refreshedById = new Map(
    refreshedToDos.map((toDo) => [toDo.toDoId, toDo]),
  );
  const retainedIds = new Set<number>();

  const retainedToDos = currentToDos.flatMap((toDo) => {
    const refreshedToDo = refreshedById.get(toDo.toDoId);

    if (refreshedToDo) {
      retainedIds.add(toDo.toDoId);
      return [{
        ...refreshedToDo,
        isRead: locallyReadToDoIds.has(toDo.toDoId) || refreshedToDo.isRead,
      }];
    }

    if (locallyReadToDoIds.has(toDo.toDoId)) {
      retainedIds.add(toDo.toDoId);
      return [{ ...toDo, isRead: true }];
    }

    return [];
  });

  const addedToDos = refreshedToDos.filter((toDo) => !retainedIds.has(toDo.toDoId));
  const pageSize = Math.max(currentToDos.length, refreshedToDos.length);

  return [...retainedToDos, ...addedToDos].slice(0, pageSize);
}
